import React from "react";

const Logist = ({ logistDisplayName }) => {
    if (!logistDisplayName) {
        return null;
    }
    return (
        <>
            <div className="show-bid__main-info--title">Логист</div>
            <div className="show-bid__main-info--value" data-test-id="logist">
                {logistDisplayName}
            </div>
        </>
    );
};

export default Logist;
